import get from 'lodash/get';

import { getIsAndroidDevice, getIsIOSDevice } from '@/utility/navigator';

export const getMediaUrlForActiveConnection = (
  heroMediaMedBitrateUrl: string,
  heroMediaHighBitrateUrl: string,
) => {
  try {
    const speed = get(navigator, 'connection.effectiveType');

    // If the connection speed is not available, default to
    // high bitrate for desktop and med bitrate for mobile devices.
    if (!speed) {
      if (getIsAndroidDevice() || getIsIOSDevice()) {
        return heroMediaMedBitrateUrl;
      }

      return heroMediaHighBitrateUrl;
    }

    if (speed === '4g') {
      return heroMediaHighBitrateUrl;
    }

    if (speed === '3g') {
      return heroMediaMedBitrateUrl;
    }
  } catch {
    return undefined;
  }
};
